import { render, staticRenderFns } from "./CabeceraModalCreacion.vue?vue&type=template&id=87d6f486&scoped=true&"
import script from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalCreacion.vue?vue&type=style&index=0&id=87d6f486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d6f486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('87d6f486', component.options)
    } else {
      api.reload('87d6f486', component.options)
    }
    module.hot.accept("./CabeceraModalCreacion.vue?vue&type=template&id=87d6f486&scoped=true&", function () {
      api.rerender('87d6f486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/ListadoEjecutivos/CabeceraModalCreacion.vue"
export default component.exports